"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgInfo = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const ContextItem_1 = require("../../ContextItem");
const DateTime_1 = require("../../../../1-inline/DateTime");
const Bytes_1 = require("../../../../1-inline/Bytes");
const OptionalBadge_1 = require("./OptionalBadge");
const ArgInfo = ({ param }) => {
    const [t] = (0, use_t_1.useT)();
    const label = param.display?.() ?? t(param.name ?? param.id ?? '');
    let content = null;
    if (param.render) {
        content = param.render();
    }
    else if (param.value !== undefined) {
        const variant = param.variant ?? 'text';
        if (variant === 'date') {
            content = React.createElement(DateTime_1.DateTime, { value: param.value });
        }
        else if (variant === 'bytes') {
            content = React.createElement(Bytes_1.Bytes, { value: param.value });
        }
        else {
            content = React.createElement("span", null, String(param.value));
        }
    }
    return (React.createElement(ContextItem_1.ContextItem, { icon: param.icon?.(), control: true, inset: true, style: { paddingTop: 6, paddingBottom: 6 }, right: React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center' } }, content) },
        React.createElement("span", null,
            label,
            param.optional && React.createElement(OptionalBadge_1.OptionalBadge, null))));
};
exports.ArgInfo = ArgInfo;
